export const PROOF_ACCESS_PERMISSIONS = {
  OWNED_ONLY: 1,
  TEAMS_ONLY: 2,
  EVERYTHING: 3,
  NONE: 4,
};

export const DOC_TYPES = {
  VIDEO: "video",
  HTML: "html",
  AUDIO: "audio",
  IMAGE: "image",
  DOCUMENT: "document",
  WEB_URL: "web_url"
}

export const ANNOTATION_TYPES = {
  DRAW: 'draw',
  ARROW: 'arrow',
  RECT: 'rect',
  POINT: 'point'
}

export const PROOF_VIEW_MODES = {
  APPROVER_MODE: 0,
  PROOF_OWNER_MODE: 1,
  COMMENTER_MODE: 2,
}

export const TYPES_ENUM = {
  STRING: 'string',
  FUNCTION: 'function'
}

export const DEFAULT_ACCOUNT_NAME = "Ashore";
export const DEFAULT_ACCOUNT_LOGO = "img/logo-large.svg"

export const DEFAULT_PADDING = {
   DEFAULT_X_PADDING: 15,
   DEFAULT_Y_PADDING: 10
}

export const CURSOR_TYPE = {
  DEFAULT: 'default',
  MOVE: 'move',
  POINTER: 'pointer'
}

export const SSO_PROVIDERS = {
  MICROSOFT: "microsoft",
  GOOGLE: "google"
}

export const NOTIFICATION_FREQUENCY_OPTIONS = {
  NEVER: 0,
  WHEN_USER_SESSION_ENDS: 1,
  EVERY_10_MINUTES: 2,
  EVERY_30_MINUTES: 3,
  EVERY_HOUR: 4,
  DAILY: 5
}

export const FILE_TYPE = {
  PDF: 'application/pdf',
}

export const PREFLIGHT_STATUS = {
  COMPLETED: 'Completed',
  PROCESSING: 'Processing',
  ERROR: 'Error',
  FAILED: 'Failed'
}

export const PLAN_SKU_TYPES = {
  FREE_PLAN: 'free',
  SUSPENDED_PLAN: 'suspended',
  TRIAL_PLAN: 'trial',
  PREMIUM_PLAN: 'premium'
}

export const PREFLIGHT_PRICES = {
  'preflights': 46,
  'preflights-annual': 33
};

export const PLAN_PUBLIC_NAMES = {
  FREE: 'Free',
  STANDARD: 'Standard',
  PREMIUM: 'Premium',
  SUSPENDED: 'Suspended',
}

export const PLAN_DESCRIPTION = {
  FREE_DESCRIPTION: "Perfect for learning Ashore",
  STANDARD_DESCRIPTION: "All of Ashore with limited branding",
  STANDARD_1_DESCRIPTION: "All of Ashore with limited branding",
  STANDARD_2_DESCRIPTION: "All of Ashore with limited branding - includes 3 users",
  PREMIUM_DESCRIPTION: "Unlimited files and full branding - includes 5 users",
  PREMIUM_1_DESCRIPTION: "Unlimited files and full branding - includes 5 users",
  PREMIUM_2_DESCRIPTION: "Unlimited files and full branding - includes 5 users"
}

export const PLAN_FEATURES = {
  FREE_FEATURES: [
    "Send 30 files per month",
    "Unlimited approvers",
    "Limited to one user",
    "1GB storage limit",
    "1 custom property",
  ],
  STANDARD_FEATURES: [
    "Includes 3 users, then $19/user/month",
    "Send 150 files per user per month",
    "Unlimited storage for 1 year per file",
    "Integrate your email and logo",
    "Unlock video and audio proofing",
    "Full automation",
    "1 free training session",
    "Integrate with Zapier",
    "Access to Adobe plugins"
  ],
  STANDARD_1_FEATURES: [
    "$18/user/month - per user pricing",
    "Send 150 files per user per month",
    "Unlimited storage for 1 year per file",
    "Integrate your email and logo",
    "Unlock video and audio proofing",
    "Full automation",
    "1 free training session",
    "Integrate with Zapier",
    "Access to Adobe plugins"
  ],
  STANDARD_2_FEATURES: [
    "Includes 3 users, then $19/user/month",
    "Send 150 files per user per month",
    "Unlimited storage for 1 year per file",
    "Integrate your email and logo",
    "Unlock video and audio proofing",
    "Full automation",
    "1 free training session",
    "Integrate with Zapier",
    "Access to Adobe plugins"
  ],
  PREMIUM_FEATURES: [
    "Includes 5 users, then $29/user/month",
    "Send unlimited files per month",
    "Unlimited storage for 2 years per file",
    "Full branding & custom domain",
    "Unlimited custom properties",
    "API access",
    "Personalized training",
    "Priority support"
  ],
  PREMIUM_1_FEATURES: [
    "Includes 5 users, then $33/user/month",
    "Send unlimited files per month",
    "Unlimited storage for 2 years per file",
    "Full branding & custom domain",
    "Unlimited custom properties",
    "API access",
    "Personalized training",
    "Priority support"
  ],
  PREMIUM_2_FEATURES: [
    "Includes 5 users, then $29/user/month",
    "Send unlimited files per month",
    "Unlimited storage for 2 years per file",
    "Full branding & custom domain",
    "Unlimited custom properties",
    "API access",
    "Personalized training",
    "Priority support"
  ]
}

export const FAQS = [
  {
    question: "What do I get with a paid plan?",
    answer: `<p>With a paid plan on Ashore, you get access to advanced features that streamline your proofing workflow, including:</p>
             <ul>
             <li>More Proofs – Send as many proofs as you need and invite unlimited reviewers.</li>
             <li>White Labeling – Customize Ashore with your branding.</li>
             <li>Integrations & API Access – Connect with third-party apps for seamless collaboration.</li>
             <li>Enhanced Storage – We store your files for up to 24 months!</li>
             </ul>
             <p class='last-para'>Paid plans are designed for teams that need more control, automation, and customization in their proofing process.</p>`,
  },
  {
    question: "Can I cancel my subscription at any time?",
    answer: `<p class='last-para'>Yes, you can cancel your Ashore subscription at any time. After cancellation, your account will be suspended, meaning you'll retain full access to your information but won't be able to send new files.</p>`,
  },
  {
    question: "Can I upgrade or downgrade plans?",
    answer: `<p class='last-para'>Yes, you can upgrade or downgrade your Ashore plan at any time. When upgrading, new features will be available immediately. If you downgrade, changes will immediately take effect.</p>`,
  },
  {
    question: "Do you offer a free trial?",
    answer: `<p class='last-para'>Ashore offers a Forever Free Plan that allows you to use the platform with some limitations. While you can send proofs and collaborate with reviewers, the free plan has restrictions on storage and the number of files you can manage. Additionally, you won't be able to integrate your email or white-label your account. If you need more flexibility and advanced features, upgrading to a paid plan is the way to go.</p>`,
  },
  {
    question: "Are there any additional fees?",
    answer: `<p class='last-para'>There are no additional fees beyond your subscription cost, but Ashore does offer add-on subscriptions that can be added to your plan to unlock additional features. One example is our Preflights tool, which ensures PDFs are print-ready in seconds. These optional add-ons provide enhanced functionality without requiring a full plan upgrade.</p>`,
  },
  {
    question: "Do you offer refunds?",
    answer: `<p class='last-para'>No, Ashore does not offer refunds under any circumstances. All purchases are final, so we recommend taking advantage of our Forever Free Plan to ensure Ashore meets your needs before upgrading to a paid plan.</p>`,
  },
]

export const MEASUREMENT_UNITS = {
  INCHES: "Inches",
  MILLIMETERS: "Millimeters"
};

export const MEASUREMENT_SYSTEMS = {
  IMPERIAL: "imperial",
  METRIC: "metric"
};

export const ROUTES = {
  ONBOARDING: '/onboarding',
  OVERVIEW: '/overview',
  BILLING: '/billing'
}

export const ALERT_TYPE = {
  SUCCESS: 'success',
  WARNING: 'warning',
}

export const ONBOARDING_STEPS = {
  WELCOME: 1,
  PROOFING_DEFAULTS: 2,
  CHECKLIST_STEP: 3,
  SUBSCRIPTION_STEP: 4
}

export const ONBOARDING_TODO_STATES = {
  HAS_CREATED_PROOF: 'hasCreatedProof',
  HAS_REVIEW_LINK_REGISTERED: 'hasReviewLinkRegistered',
  HAS_EMAIL_TEMPLATE_CREATED: 'hasEmailTemplateCreated',
  HAS_USED_WORKFLOW: 'hasUsedWorkflow'
}

export const ONBOARDING_TODO_ITEMS = {
  CREATE_CHECKLIST: {
    title: 'Create an Approval Checklist',
    description: 'Outline what reviewers should look for before hitting "approve." It\'s your quality control, built right in.',
    duration: '',
    completed: true
  },
  CREATE_PROOF: {
    headingIcon: '\uD83D\uDE80',
    heading: 'Proof Created!',
    subHeading: 'Your first proof is live! Now the real magic begins—time to gather feedback and approvals with ease.',
    title: 'Create a Proof',
    description: 'Upload a file and start a new proof. This is where your review process begins—just drag, drop, and go.',
    duration: '3 Minutes',
    completed: false,
    icon: 'paper-clip.svg'
  },
  SHARE_REVIEW_LINK: {
    headingIcon: '\uD83D\uDD17',
    heading: 'Approver Registered to a Proof',
    subHeading: 'An approver just registered to your proof via a review link. No logins, no hassle—just a smooth ride to feedback.',
    title: 'Share a Review Link',
    description: 'Send a proof manually and see how the review process works from start to finish—fast, no login required.',
    duration: '1 Minute',
    completed: false,
    icon: 'link.svg'
  },
  CREATE_EMAIL_TEMPLATE: {
    headingIcon: '\u2709\uFE0F',
    heading: 'Email, Your Way',
    subHeading: 'Your reviewers will appreciate that personal touch—email templates are set and looking great.',
    title: 'Create an Email Template',
    description: 'Customize the emails your reviewers will receive. Make them feel like it came from you, not a robot.',
    duration: '5 Minutes',
    completed: false,
    icon: 'mail.svg'
  },
  SEND_WORKFLOW: {
    headingIcon: '\uD83D\uDCEC',
    heading: 'Workflow Activated!',
    subHeading: 'Your review process just got smarter. Workflows are live and ready to automate approvals like a pro.',
    title: 'Send a Proof via a Workflow',
    description: 'Use a workflow to automate your review process. Set the order, assign reviewers, and let Ashore handle the rest.',
    duration: '2 Minutes',
    completed: false,
    icon: 'share.svg'
  }
}

export const SETUP_RESOURCES = {
  NEW_ACCOUNT: {
    title: 'I just made an account, what should I do?',
    link: 'https://kb.ashoreapp.com/i-just-made-an-account-what-should-i-do/'
  },
  SEND_PROOF: {
    title: 'How do I send a proof?',
    link: 'https://kb.ashoreapp.com/how-do-i-send-a-proof/'
  },
  ADOBE_PLUGINS: {
    title: 'How Do I Use Ashore\'s Adobe Plugins?',
    link: 'https://kb.ashoreapp.com/how-do-i-install-ashores-adobe-beta-plugin/'
  }
}

export const GREETINGS = {
  MORNING: 'Good Morning',
  AFTERNOON: 'Good Afternoon',
  EVENING: 'Good Evening'
}

export const EXPIRED_COOKIE_DATE = "Thu, 01 Jan 1970 00:00:00 UTC";

export const FILE_APPROVAL_STATUS = {
  APPROVED: '1',
  APPROVED_WITH_CHANGES: '2',
  REJECTED_INDIVIDUAL: '3',
  REJECTED: "0"
}

export const USER_ACTION = {
  APPROVE: 'approve',
  REJECT: 'reject',
}

export const FILE_PROPERTIES = {
  APPROVAL_FEEDBACK: 'approvalFeedback',
  REVIEW_ACTION: 'userAction'
}

export const USER_NOT_FOUND_MESSAGE = "User Does Not Exist. Please check your credentials";

export const MODAL_NAMES = {
  ONBOARDING_MODEL: 'OnboardingStepModal',
  PROOF_CREATED: 'proofCreated',
  GATED_FEATURES_MODAL: 'gatedFeaturesModal',
  PREMIUM_CHECKLIST_MODAL: 'premiumChecklistModal',
  NEW_USER_MODAL: 'NewUserWelcomeModal'
}

export const PREMIUM_FEATURES_KEYS = {
  CHECKLIST: 'CHECKLIST',
  EMAIL_TEMPLATE: 'EMAIL_TEMPLATE', 
  INTEGRATION: 'INTEGRATION'
}

export const PREMIUM_FEATURE_CONTENT = {
  WORKFLOWS: {
    badge: "Upgrade to Unlock Workflows",
    title: "Work Smarter and {Speed Up} Turnaround Times",
    description: "Create custom workflows to keep every proof on track—without the manual follow-up.",
    features: [
      "Build approval stages with specific reviewers",
      "Send personalized emails automatically at each step",
      "Attach required checklists to stages",
      "Standardize and automate the full review cycle"
    ],
    upgradeText: "Upgrade Now",
    maybeLaterText: "Talk to Sales"
  },
  CHECKLIST: {
    badge: "Upgrade to Unlock Checklists",
    title: "Create Custom Checklists for {Every Job}",
    description: "Different jobs need different checks. Add as many checklists as you need to stay thorough at every stage.",
    features: [
      "Use unique checklists for internal and customer review stages",
      "Tailor sign-off requirements to each job type",
      "Ensure nothing gets missed, no matter the workflow",
      "Keep your team aligned on what's required and when"
    ],
    upgradeText: "Upgrade Now",
    maybeLaterText: "Maybe Later"
  },
  EMAIL_TEMPLATE: {
    badge: "Upgrade to Unlock Email Templates",
    title: "Save {Time} with Email Templates",
    description: "Write it once, use it everywhere. Create reusable emails that feel personal every time.",
    features: [
      "Customize messages with variables like client name, due date, and more",
      "Reuse templates in Workflows or send them manually",
      "Keep messaging consistent across your team",
      "Eliminate repetitive copy-paste work"
    ],
    upgradeText: "Upgrade Now",
    maybeLaterText: "Maybe Later"
  },
  INTEGRATION: {
    badge: "Upgrade to Unlock Integrations",
    title: "Connect Ashore to the Tools {You Already Use}",
    description: "Integrate Ashore into your existing workflow with just a few clicks.",
    features: [
      "Automate tasks with Zapier (connect to over 5,000 apps)",
      "Send and manage proofs directly from Adobe Photoshop, Illustrator and InDesign",
      "Build custom integrations using our API (Premium only)"
    ],
    upgradeText: "Upgrade Now",
    maybeLaterText: "Maybe Later"
  }
};

export const ACCOUNT_SETTING_TABS = {
  ORGANIAZATION: 0,
  PROPERTIES: 1,
  BRANDING: 2,
  INTEGRATION: 3,
}
